export enum EnvironmentTypeEnum {
  local = 1,
  staging = 2,
  develop = 3,
  production = 4
}
